import { Component, OnInit, ViewChild } from '@angular/core';
import { GeolocationService } from '../services/geolocation.service';
import { } from '@types/googlemaps';
import { UUID } from 'angular2-uuid';
//grid
import { AgGridNg2 } from 'ag-grid-angular';

import { ReportePuntoVisitaCertificadoDistancia } from '../Models/ReportePuntoVisitaCertificadoDistancia';


import { PuntoVisitaService } from '../services/punto-visita.service';
import { GlobalsService } from '../services/globals.service';
@Component({
  selector: 'app-reporte-punto-visita-distancia',
  templateUrl: './reporte-punto-visita-distancia.component.html',
  styleUrls: ['./reporte-punto-visita-distancia.component.css']
})
export class ReportePuntoVisitaDistanciaComponent implements OnInit {


  @ViewChild('gmap') gmapElement: any;
  map: google.maps.Map;

  public punto: ReportePuntoVisitaCertificadoDistancia = new ReportePuntoVisitaCertificadoDistancia();
  public puntos: ReportePuntoVisitaCertificadoDistancia[];


  public mostrarMapa: boolean = false;
  public modoEdicion: boolean = false;

  public markers = [];

  /**
   * Estructura para la tabla
   */
  columnDefs = [
    { headerName: 'Nombre Punto Visita', field: 'nombrePunto', icons: { filter: ' ' } },
    { headerName: 'Dirección', field: 'direccion', icons: { filter: ' ' } },
    { headerName: 'Distancia', field: 'distancia', icons: { filter: ' ' } },

  ];

  //Array donde se carga la informacion para la tabla
  rowData: any[];

  constructor(
    private geoService: GeolocationService,
    private puntoVisitaService: PuntoVisitaService,
    private globalServices: GlobalsService
  ) { }

  ngOnInit() {
    this.CargarPuntos();
  }




  /**
   * carga la lista de los puntos de visita por distancia de certificacion
   */
  CargarPuntos() {
    try {

      this.puntoVisitaService.ObtenerReportePuntoVisitaDistanciaCertificacion(this.globalServices.ObtenerCompania()).subscribe(
        data => {
          this.puntos = data;

          this.rowData = this.puntos;

        },
        err => {
          console.clear();
          console.log(err._body);

        });


    } catch (error) {
      console.log("CargarPuntosLocalizacion: " + error);
    }

  }



  /**
   * cuando le da click en un row
   * @param  event Contiene la informacion de la fila de la tabla
   */
  private onCellClicked($event) {

    console.log('onCellClicked: ' + $event.rowIndex + ' ' + $event.colDef.field);
    let row = $event.rowIndex;
    let datos = JSON.parse(JSON.stringify($event.data));

    //Se debe clonar el item para que no afecte el array origen en memoria
    this.modoEdicion = true;

    this.punto = datos;

    this.obtenerPuntoVisita();
  }

  /**
   * Carga la instancia del mapa, el cual crea y centra el mapa
   */
  cagarMapa() {

    this.map = new google.maps.Map(this.gmapElement.nativeElement, {
      center: {
        lat: parseFloat(this.punto.latitudCertificacion),
        lng: parseFloat(this.punto.longitudCertificacion)
      },
      zoom: 15
    });

  }

  /**
   * Dibuja los markes con las cordenadas dadas
   * @param latitud latitud para el marker
   * @param longitud longitud para el marker
   * @param nombrePunto nombre que va tener el marker
   * @param tipo "viejo", es el punto de visita original  ,"certificacion" es el punto de visita de la 
   * certificacion, el cual va hacer el nuevo punto de visita si es actualizado
   */
  dibujarMapa(latitud: string, longitud: string, nombrePunto: string, tipo: string) {
    try {

      if (tipo === "viejo") {
        var contenido = "<div> <h1>Punto de visita: " + nombrePunto + "</h1>  <br> <h2>Punto de visita original  </h2></div>";
      }
      else {
        var contenido = "<div> <h1>Punto de visita: " + nombrePunto + "</h1>  <br> <h2>Punto de visita del certificado  </h2></div>";
      }

      var marker = new google.maps.Marker({

        position: { lat: parseFloat(latitud), lng: parseFloat(longitud) },
        map: this.map,
        title: "",

      }),
        infowindow = new google.maps.InfoWindow({
          content: contenido
        });

      google.maps.event.addListener(marker, 'click', function () {

        infowindow.open(this.map, marker);

      });

      this.markers.push(marker);



    } catch (error) {

    }
  }

  /**
   * Devuelve de nuevo al menu de reporte de puntos de visita distancia
   */
  CancelarPunto() {

    this.modoEdicion = false;
  }

  /**
   * Obtiene los datos del punto de visita espesifico
   * @param this.punto.idPunto id del punto de visita
   */
  obtenerPuntoVisita() {
    try {

      this.puntoVisitaService.ObtenerPuntoVisita(this.globalServices.ObtenerCompania(), this.punto.idPunto).subscribe(
        data => {
          var datos = data;


          this.cagarMapa();
          this.dibujarMapa(this.punto.latitud, this.punto.longitud, this.punto.nombrePunto, "viejo");
          this.dibujarMapa(this.punto.latitudCertificacion, this.punto.longitudCertificacion, this.punto.nombrePunto, "certificacion");
        },
        err => {
          console.clear();
          console.log(err._body);

        });


    } catch (error) {
      console.log("obtenerPuntoVisita: " + error);
    }

  }


  /**
   * Actualiaza el punto de visita, el viejo por el de certificacion 
   */
  GuardarRegistro() {

    this.puntoVisitaService.ActualizarPuntoVisitaDistanciaCertificacion(this.globalServices.ObtenerCompania(), this.punto.idPunto, this.punto.longitudCertificacion, this.punto.latitudCertificacion).subscribe(

      result => {

        swal("Registro guardado con éxito!", "", "success");

        this.punto = new ReportePuntoVisitaCertificadoDistancia();
        this.modoEdicion = false;

        this.CargarPuntos();
      },
      err => {
        console.log(err._body);
      });


  }

  RechazarRegistro(){

    this.puntoVisitaService.RechazarPuntoVisitaDistanciaCertificacion(this.globalServices.ObtenerCompania(), this.punto.idPunto).subscribe(

      result => {

        swal("Registro rechazado con éxito!", "", "success");

        this.punto = new ReportePuntoVisitaCertificadoDistancia();
        this.modoEdicion = false;

        this.CargarPuntos();
      },
      err => {
        console.log(err._body);
        swal("Ocurrio un error", "", "error");
      });


  }

  

}
